import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, } from "reactstrap";
const FbTokenModal = ({ isOpen, toggle, selected, onSave, }) => {

  const [form, setForm] = useState({ name: "", refId: "", accessToken: "", type: "page", });

  useEffect(() => {
    if (selected) {
      setForm({
        name: selected?.name || "",
        refId: selected?.refId || "",
        accessToken: selected?.accessToken || "",
        type: selected?.type || "page",
      });
    }
  }, [selected]);

  const handleSubmit = async () => {
    if (selected) {
      await onSave(selected._id, form);
    } else {
      await onSave(form);
    }

    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        {selected ? "Update Token" : "Create Token"}
      </ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <Label>Name</Label>

          <Input
            value={form.name}
            onChange={(e) =>
              setForm({
                ...form,
                name: e.target.value,
              })
            }
          />
        </div>

        <div className="mb-3">
          <Label>Reference ID</Label>

          <Input
            value={form.refId}
            onChange={(e) =>
              setForm({
                ...form,
                refId: e.target.value,
              })
            }
          />
        </div>

        <div className="mb-3">
          <Label>Type</Label>

          <Input
            type="select"
            value={form.type}
            onChange={(e) =>
              setForm({
                ...form,
                type: e.target.value,
              })
            }
          >
            <option value="page">Page</option>
            <option value="user">User</option>
          </Input>
        </div>

        <div className="mb-3">
          <Label>Access Token</Label>

          <Input
            type="textarea"
            rows="6"
            value={form.accessToken}
            onChange={(e) =>
              setForm({
                ...form,
                accessToken: e.target.value,
              })
            }
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>

        <Button color="primary" onClick={handleSubmit}>
          {selected ? "Update" : "Create"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FbTokenModal;
